import BuildTreeTestUtils from "./test_utils/build_tree_test_utils.mjs";
function deceasedMale_bothParents_oneSon_oneDaughter() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addNSons(self, 1, 1);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    return self;
}
function deceasedMale_bothParents_twoSons_oneDaughter() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addNSons(self, 2, 2);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    return self;
}
function deceasedMale_fourSons_oneDaughter() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNSons(self, 4, 4);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    return self;
}
function deceasedMale_bothParents() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, true);
    return self;
}
function deceasedMale_twoDaughters() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNDaughters(self, 2, 2);
    return self;
}
function deceasedMale_fiveDaughters() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNDaughters(self, 5, 5);
    return self;
}
function deceasedMale_threeSons() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNSons(self, 3, 3);
    return self;
}
function deceasedMale_oneSon_twoDaughters() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNSons(self, 1, 1);
    BuildTreeTestUtils._addNDaughters(self, 2, 2);
    return self;
}
function deceasedMale_mother_oneWife_oneSon() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNSons(self, 1, 1);
    return self;
}
function deceasedFemale_bothParents_husband() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addMother(self, true);
    return self;
}
function deceasedMale_bothParents_wife() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    return self;
}
function deceasedMale_mother_oneWife_oneDaughter() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    return self;
}
function deceasedFemale_husband_oneSon() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNSons(self, 1, 1);
    return self;
}
function deceasedFemale_husband_oneSon_oneDaughter() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNSons(self, 1, 1);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    return self;
}
function deceasedFemale_father_husband_oneDaughter() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    return self;
}
function deceasedMale_father_oneWife_oneSon() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNSons(self, 1, 1);
    return self;
}
function deceasedMale_oneDaughter_twoGrandDaughters_singleDeceasedSon() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addNGrandDaughters(self, 2, 1);
    return self;
}
function deceasedMale_oneDaughter_twoGrandDaughters_multipleDeceasedSons() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addNGrandDaughters(self, 2, 2);
    return self;
}
function deceasedMale_oneDaughter_oneGrandSon_singleDeceasedSon() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addNGrandSons(self, 1, 1);
    return self;
}
function deceasedMale_oneDaughter_oneGrandSon_multipleDeceasedSons() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addNGrandSons(self, 1, 3);
    return self;
}
function deceasedMale_twoDaughters_oneGrandSon_singleDeceasedSon_oneGrandDaughter_singleDeceasedSon() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNDaughters(self, 2, 2);
    BuildTreeTestUtils._addNGrandSons(self, 1, 1);
    BuildTreeTestUtils._addNGrandDaughters(self, 1, 1);
    return self;
}
function deceasedFemale_husband_oneGrandSon_singleDeceasedSon_twoGrandDaughters_singleDeceasedSon() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNGrandSons(self, 1, 1);
    BuildTreeTestUtils._addNGrandDaughters(self, 2, 1);
    return self;
}
function deceasedFemale_husband_oneGrandSon_singleDeceasedSon_twoGrandDaughters_multipleDeceasedSons() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNGrandSons(self, 1, 1);
    BuildTreeTestUtils._addNGrandDaughters(self, 2, 2);
    return self;
}
function deceasedMale_twoDaughters_threeGrandSons_singleDeceasedSon_twoGrandDaughters_singleDeceasedSon() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNDaughters(self, 2, 2);
    BuildTreeTestUtils._addNGrandSons(self, 3, 1);
    BuildTreeTestUtils._addNGrandDaughters(self, 2, 1);
    return self;
}
function deceasedMale_twoDaughters_threeGrandSons_singleDeceasedSon_twoGrandDaughters_multipleDeceasedSons() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNDaughters(self, 2, 2);
    BuildTreeTestUtils._addNGrandSons(self, 3, 1);
    BuildTreeTestUtils._addNGrandDaughters(self, 2, 3);
    return self;
}
function deceasedMale_twoDaughters_threeGrandSons_multipleDeceasedSons_twoGrandDaughters_singleDeceasedSon() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNDaughters(self, 2, 2);
    BuildTreeTestUtils._addNGrandSons(self, 3, 2);
    BuildTreeTestUtils._addNGrandDaughters(self, 2, 1);
    return self;
}
function deceasedMale_twoDaughters_threeGrandSons_multipleDeceasedSons_twoGrandDaughters_multipleDeceasedSons() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNDaughters(self, 2, 2);
    BuildTreeTestUtils._addNGrandSons(self, 3, 4);
    BuildTreeTestUtils._addNGrandDaughters(self, 2, 2);
    return self;
}
function deceasedMale_grandFather() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addGrandFather(self, true);
    return self;
}
function deceasedMale_paternalGrandMother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addPaternalGrandMother(self, true);
    return self;
}
function deceasedMale_maternalGrandMother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addMaternalGrandMother(self, true);
    return self;
}
function deceasedMale_father_grandFather_paternalGrandMother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addPaternalGrandMother(self, true);
    return self;
}
function deceasedMale_mother_grandFather_paternalGrandMother_maternalGrandMother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addPaternalGrandMother(self, true);
    BuildTreeTestUtils._addMaternalGrandMother(self, true);
    return self;
}
function deceasedMale_bothParents_grandFather_paternalGrandMother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addPaternalGrandMother(self, true);
    return self;
}
function deceasedMale_bothParents_grandFather_maternalGrandMother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addMaternalGrandMother(self, true);
    return self;
}
function deceasedMale_grandFather_paternalGrandMother_maternalGrandMother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addMaternalGrandMother(self, true);
    BuildTreeTestUtils._addPaternalGrandMother(self, true);
    return self;
}
function deceasedMale_twoSons_grandFather_maternalGrandMother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addNSons(self, 2, 2);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addMaternalGrandMother(self, true);
    return self;
}
function deceasedMale_twoSons_threeDaughters_grandFather_maternalGrandMother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addNSons(self, 2, 2);
    BuildTreeTestUtils._addNDaughters(self, 3, 3);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addMaternalGrandMother(self, true);
    return self;
}
function deceasedMale_threeDaughters_grandFather_maternalGrandMother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addNDaughters(self, 3, 3);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addMaternalGrandMother(self, true);
    return self;
}
function deceasedMale_grandFather_maternalGrandMother_twoGrandSons_singleDeceasedSon() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addMaternalGrandMother(self, true);
    BuildTreeTestUtils._addNGrandSons(self, 2, 1);
    return self;
}
function deceasedMale_grandFather_maternalGrandMother_twoGrandDaughters_singleDeceasedSon() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addMaternalGrandMother(self, true);
    BuildTreeTestUtils._addNGrandDaughters(self, 2, 1);
    return self;
}
function deceasedMale_grandFather_maternalGrandMother_twoGrandSons_multipleDeceasedSons_twoGrandDaughters_multipleDeceasedSons() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addMaternalGrandMother(self, true);
    BuildTreeTestUtils._addNGrandSons(self, 2, 3);
    BuildTreeTestUtils._addNGrandDaughters(self, 2, 3);
    return self;
}
function deceasedMale_oneDaughter_twoFullSisters() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addNFullSisters(self, 2, 2);
    return self;
}
function deceasedMale_oneDaughter_oneGrandDaughter_singleDeceasedSon_twoFullSisters() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addNGrandDaughters(self, 1, 1);
    BuildTreeTestUtils._addNFullSisters(self, 2, 2);
    return self;
}
function deceasedFemale_husband_twoFullSisters() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNFullSisters(self, 2, 2);
    return self;
}
function deceasedMale_mother_oneFullSister() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    return self;
}
function deceasedMale_oneWife_twoFullSisters() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNFullSisters(self, 2, 2);
    return self;
}
function deceasedMale_bothParents_twoFullSisters() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addNFullSisters(self, 2, 2);
    return self;
}
function deceasedFemale_husband_oneFullSister() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    return self;
}
function deceasedFemale_mother_husband_oneDaughter_oneFullSister() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    return self;
}
function deceasedMale_oneWife_twoDaughters_oneFullSister() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNDaughters(self, 2, 2);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    return self;
}
function deceasedMale_twoGrandDaughters_singleDeceasedSon_threeFullSisters() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNGrandDaughters(self, 2, 1);
    BuildTreeTestUtils._addNFullSisters(self, 3, 3);
    return self;
}
function deceasedMale_oneDaughter_oneGrandDaughter_singleDeceasedSon_twoFullSister() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addNGrandDaughters(self, 1, 1);
    BuildTreeTestUtils._addNFullSisters(self, 2, 2);
    return self;
}
function deceasedMale_threeDaughters_threeFullSisters() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNDaughters(self, 3, 3);
    BuildTreeTestUtils._addNFullSisters(self, 3, 3);
    return self;
}
function deceasedFemale_husband_paternalGrandMother_oneFullSister() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addPaternalGrandMother(self, true);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    return self;
}
function deceasedMale_oneFullBrother_oneFullSister() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    return self;
}
function deceasedMale_mother_oneFullBrother_twoFullSisters() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    BuildTreeTestUtils._addNFullSisters(self, 2, 2);
    return self;
}
function deceasedMale_father_oneFullBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    return self;
}
function deceasedMale_mother_oneWife_oneDaughter_oneFullBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    return self;
}
function deceasedMale_mother_twoFullBrothers() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNFullBrothers(self, 2, 2);
    return self;
}
function deceasedMale_oneWife_oneDaughter_oneFullBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    return self;
}
function deceasedFemale_mother_husband_oneFullBrother() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    return self;
}
function deceasedMale_bothParents_oneWife_oneDaughter_oneFullBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    return self;
}
function deceasedFemale_oneFullBrother_oneFullSister() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    return self;
}
function deceasedMale_twoFullBrothers_oneFullSister() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNFullBrothers(self, 2, 2);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    return self;
}
function deceasedMale_mother_oneWife_oneDaughter_oneGrandDaughter_oneFullBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addNGrandDaughters(self, 1, 1);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    return self;
}
function deceasedMale_oneWife_threeDaughters_paternalGrandMother_oneFullBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNDaughters(self, 3, 3);
    BuildTreeTestUtils._addPaternalGrandMother(self, true);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    return self;
}
function deceasedMale_oneWife_threeDaughters_oneFullBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNDaughters(self, 3, 3);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    return self;
}
function deceasedMale_father_twoWives_oneDaughter_oneGrandFather_oneFullBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addNWives(self, 2, 2);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    return self;
}
function deceasedMale_bothParents_oneSon_oneFullBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addNSons(self, 1, 1);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    return self;
}
function deceasedFemale_bothParents_husband_twoSons_oneDaughter_grandFather_oneFullBrother() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNSons(self, 2, 2);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    return self;
}
function deceasedMale_grandFather_threeFullBrothers() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addNFullBrothers(self, 3, 3);
    return self;
}
function deceasedFemale_husband_oneDaughter_grandFather_oneGrandDaughter_oneFullBrother() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNDaughters(self, 1, 1);
    BuildTreeTestUtils._addGrandFather(self, true);
    BuildTreeTestUtils._addNGrandDaughters(self, 1, 1);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    return self;
}
function deceasedFemale_husband_oneFullBrother_oneFullSister() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    return self;
}
function deceasedFemale_mother_husband_twoFullBrothers_twoMaternalBrothers() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addNFullBrothers(self, 2, 2);
    BuildTreeTestUtils._addNMaternalBrothers(self, 2, 2);
    return self;
}
function deceasedMale_paternalGrandMother_oneFullSister_oneMaternalBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addPaternalGrandMother(self, true);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    BuildTreeTestUtils._addNMaternalBrothers(self, 1, 1);
    return self;
}
function deceasedMale_mother_threeMaternalBrothers() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addNMaternalBrothers(self, 3, 3);
    return self;
}
function deceasedMale_mother_oneWife_oneMaternalBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addNMaternalBrothers(self, 1, 1);
    return self;
}
function deceasedMale_twoWives_paternalGrandMother_maternalGrandMother_twoMaternalBrothers() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addNWives(self, 2, 2);
    BuildTreeTestUtils._addPaternalGrandMother(self, true);
    BuildTreeTestUtils._addMaternalGrandMother(self, true);
    BuildTreeTestUtils._addNMaternalBrothers(self, 2, 2);
    return self;
}
function deceasedMale_twoDaughters_twoMaternalBrothers() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addNWives(self, 1, 0);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addNDaughters(self, 2, 2);
    BuildTreeTestUtils._addNMaternalBrothers(self, 2, 2);
    return self;
}
function deceasedMale_mother_onePaternalBrother_oneMaternalBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addNPaternalBrothers(self, 1, 1);
    BuildTreeTestUtils._addNMaternalBrothers(self, 1, 1);
    return self;
}
function deceasedMale_mother_oneFullBrother_oneMaternalBrother() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addNFullBrothers(self, 1, 1);
    BuildTreeTestUtils._addNMaternalBrothers(self, 1, 1);
    return self;
}
function deceasedFemale_husband_twoPaternalSisters_twoMaternalBrothers() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addNPaternalSisters(self, 2, 2);
    BuildTreeTestUtils._addNMaternalBrothers(self, 2, 2);
    return self;
}
function deceasedFemale_mother_oneFullSister_onePaternalSister_oneMaternalSister() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    BuildTreeTestUtils._addNPaternalSisters(self, 1, 1);
    BuildTreeTestUtils._addNMaternalSisters(self, 1, 1);
    return self;
}
function deceasedFemale_mother_oneFullSister_onePaternalSister_twoMaternalSisters() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    BuildTreeTestUtils._addNPaternalSisters(self, 1, 1);
    BuildTreeTestUtils._addNMaternalSisters(self, 2, 2);
    return self;
}
function deceasedMale_twoFullSisters_twoMaternalBrothers() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addNFullSisters(self, 2, 2);
    BuildTreeTestUtils._addNMaternalBrothers(self, 2, 2);
    return self;
}
function deceasedMale_mother_oneWife_twoPaternalSisters_twoMaternalBrothers() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNPaternalSisters(self, 2, 2);
    BuildTreeTestUtils._addNMaternalBrothers(self, 2, 2);
    return self;
}
function deceasedMale_oneWife_onePaternalGrandMother_twoMaternalSisters() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, false);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addPaternalGrandMother(self, true);
    BuildTreeTestUtils._addNMaternalSisters(self, 2, 2);
    return self;
}
function deceasedFemale_husband_mother_oneFullSister_onePaternalSister_oneMaternalSister() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addNFullSisters(self, 1, 1);
    BuildTreeTestUtils._addNPaternalSisters(self, 1, 1);
    BuildTreeTestUtils._addNMaternalSisters(self, 1, 1);
    return self;
}
function deceasedMale_bothParents_oneWife_twoMaternalBrothers() {
    const self = BuildTreeTestUtils._getDeceasedMaleSelf();
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addFather(self, true);
    BuildTreeTestUtils._addNWives(self, 1, 1);
    BuildTreeTestUtils._addNMaternalBrothers(self, 2, 2);
    return self;
}
function deceasedFemale_mother_husband_twoPaternalBrothers_twoMaternalBrothers() {
    const self = BuildTreeTestUtils._getDeceasedFemaleSelf();
    BuildTreeTestUtils._addHusband(self, true);
    BuildTreeTestUtils._addFather(self, false);
    BuildTreeTestUtils._addMother(self, true);
    BuildTreeTestUtils._addNPaternalBrothers(self, 2, 2);
    BuildTreeTestUtils._addNMaternalBrothers(self, 2, 2);
    return self;
}
const allTests = [
    deceasedMale_bothParents_oneSon_oneDaughter,
    deceasedMale_bothParents_twoSons_oneDaughter,
    deceasedMale_fourSons_oneDaughter,
    deceasedMale_bothParents,
    deceasedMale_twoDaughters,
    deceasedMale_fiveDaughters,
    deceasedMale_threeSons,
    deceasedMale_oneSon_twoDaughters,
    deceasedMale_mother_oneWife_oneSon,
    deceasedFemale_bothParents_husband,
    deceasedMale_bothParents_wife,
    deceasedMale_mother_oneWife_oneDaughter,
    deceasedFemale_husband_oneSon,
    deceasedFemale_husband_oneSon_oneDaughter,
    deceasedFemale_father_husband_oneDaughter,
    deceasedMale_father_oneWife_oneSon,
    deceasedMale_oneDaughter_twoGrandDaughters_singleDeceasedSon,
    deceasedMale_oneDaughter_twoGrandDaughters_multipleDeceasedSons,
    deceasedMale_oneDaughter_oneGrandSon_singleDeceasedSon,
    deceasedMale_oneDaughter_oneGrandSon_multipleDeceasedSons,
    deceasedMale_twoDaughters_oneGrandSon_singleDeceasedSon_oneGrandDaughter_singleDeceasedSon,
    deceasedFemale_husband_oneGrandSon_singleDeceasedSon_twoGrandDaughters_singleDeceasedSon,
    deceasedFemale_husband_oneGrandSon_singleDeceasedSon_twoGrandDaughters_multipleDeceasedSons,
    deceasedMale_twoDaughters_threeGrandSons_singleDeceasedSon_twoGrandDaughters_singleDeceasedSon,
    deceasedMale_twoDaughters_threeGrandSons_singleDeceasedSon_twoGrandDaughters_multipleDeceasedSons,
    deceasedMale_twoDaughters_threeGrandSons_multipleDeceasedSons_twoGrandDaughters_singleDeceasedSon,
    deceasedMale_twoDaughters_threeGrandSons_multipleDeceasedSons_twoGrandDaughters_multipleDeceasedSons,
    deceasedMale_grandFather,
    deceasedMale_paternalGrandMother,
    deceasedMale_maternalGrandMother,
    deceasedMale_father_grandFather_paternalGrandMother,
    deceasedMale_mother_grandFather_paternalGrandMother_maternalGrandMother,
    deceasedMale_bothParents_grandFather_paternalGrandMother,
    deceasedMale_bothParents_grandFather_maternalGrandMother,
    deceasedMale_grandFather_paternalGrandMother_maternalGrandMother,
    deceasedMale_twoSons_grandFather_maternalGrandMother,
    deceasedMale_twoSons_threeDaughters_grandFather_maternalGrandMother,
    deceasedMale_threeDaughters_grandFather_maternalGrandMother,
    deceasedMale_grandFather_maternalGrandMother_twoGrandSons_singleDeceasedSon,
    deceasedMale_grandFather_maternalGrandMother_twoGrandDaughters_singleDeceasedSon,
    deceasedMale_grandFather_maternalGrandMother_twoGrandSons_multipleDeceasedSons_twoGrandDaughters_multipleDeceasedSons,
    deceasedMale_oneDaughter_twoFullSisters,
    deceasedMale_oneDaughter_oneGrandDaughter_singleDeceasedSon_twoFullSisters,
    deceasedFemale_husband_twoFullSisters,
    deceasedMale_oneWife_twoDaughters_oneFullSister,
    deceasedMale_twoGrandDaughters_singleDeceasedSon_threeFullSisters,
    deceasedMale_oneDaughter_oneGrandDaughter_singleDeceasedSon_twoFullSister,
    deceasedMale_threeDaughters_threeFullSisters,
    deceasedMale_father_oneFullBrother,
    deceasedMale_oneFullBrother_oneFullSister,
    deceasedFemale_oneFullBrother_oneFullSister,
    deceasedMale_twoFullBrothers_oneFullSister,
    deceasedMale_bothParents_oneSon_oneFullBrother,
    deceasedMale_mother_oneFullSister,
    deceasedMale_oneWife_twoFullSisters,
    deceasedMale_bothParents_twoFullSisters,
    deceasedFemale_husband_oneFullSister,
    deceasedFemale_mother_husband_oneDaughter_oneFullSister,
    deceasedFemale_husband_paternalGrandMother_oneFullSister,
    deceasedMale_mother_oneFullBrother_twoFullSisters,
    deceasedMale_mother_oneWife_oneDaughter_oneFullBrother,
    deceasedMale_mother_twoFullBrothers,
    deceasedMale_oneWife_oneDaughter_oneFullBrother,
    deceasedFemale_mother_husband_oneFullBrother,
    deceasedMale_bothParents_oneWife_oneDaughter_oneFullBrother,
    deceasedMale_mother_oneWife_oneDaughter_oneGrandDaughter_oneFullBrother,
    deceasedMale_oneWife_threeDaughters_paternalGrandMother_oneFullBrother,
    deceasedMale_oneWife_threeDaughters_oneFullBrother,
    deceasedMale_father_twoWives_oneDaughter_oneGrandFather_oneFullBrother,
    deceasedFemale_bothParents_husband_twoSons_oneDaughter_grandFather_oneFullBrother,
    deceasedFemale_husband_oneFullBrother_oneFullSister,
    deceasedFemale_mother_husband_twoFullBrothers_twoMaternalBrothers,
    deceasedMale_paternalGrandMother_oneFullSister_oneMaternalBrother,
    deceasedMale_mother_threeMaternalBrothers,
    deceasedMale_mother_oneWife_oneMaternalBrother,
    deceasedMale_twoWives_paternalGrandMother_maternalGrandMother_twoMaternalBrothers,
    deceasedMale_twoDaughters_twoMaternalBrothers,
    deceasedMale_mother_onePaternalBrother_oneMaternalBrother,
    deceasedMale_mother_oneFullBrother_oneMaternalBrother,
    deceasedFemale_husband_twoPaternalSisters_twoMaternalBrothers,
    deceasedFemale_mother_oneFullSister_onePaternalSister_oneMaternalSister,
    deceasedFemale_mother_oneFullSister_onePaternalSister_twoMaternalSisters,
    deceasedMale_twoFullSisters_twoMaternalBrothers,
    deceasedMale_mother_oneWife_twoPaternalSisters_twoMaternalBrothers,
    deceasedMale_oneWife_onePaternalGrandMother_twoMaternalSisters,
    deceasedFemale_husband_mother_oneFullSister_onePaternalSister_oneMaternalSister,
    deceasedMale_bothParents_oneWife_twoMaternalBrothers,
    deceasedFemale_mother_husband_twoPaternalBrothers_twoMaternalBrothers,
    // TODO: There is a difference of opinion on how to handle inheritance when both a paternal grandfather and 1+ full brothers are present, need to see how we want to handle it in the Will generator
    // deceasedMale_grandFather_threeFullBrothers,
    // deceasedFemale_husband_oneDaughter_grandFather_oneGrandDaughter_oneFullBrother,
];
export default allTests;
